"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@app/util");
const contract_type_1 = require("@app/util/contract-type");
const filtered_content_for_organization_1 = require("@app/util/filtered-content-for-organization");
const deepmerge_1 = __importDefault(require("deepmerge"));
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("../store/initial"));
exports.default = (state = initial_1.default.organization, action) => {
    switch (action.type) {
        case action_type_1.default.SET_ORG: {
            const organizationId = action.data?.id;
            if (!(0, util_1.isValue)(organizationId)) {
                return action.data;
            }
            const enableExternalContractTypeOption = (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('enable_external_contract_type', false, undefined, organizationId);
            const countriesWithFilteredContractTypes = (action.data?.countries ?? []).map((country) => ({
                ...country,
                contractTypes: (0, contract_type_1.filterContractTypes)(enableExternalContractTypeOption)(country?.contractTypes?.filter(util_1.isValue) ?? []),
            }));
            return { ...action.data, countries: countriesWithFilteredContractTypes };
        }
        case action_type_1.default.RESET_STORE:
            return initial_1.default.organization;
        case action_type_1.default.SET_ORG_CALENDAR_LOCKING_SETTINGS:
            return (0, deepmerge_1.default)(state, { settings: { customCalendarLocking: action.data } });
        default:
            return state;
    }
};
